// removed by extract-text-webpack-plugin
module.exports = {"libraryIcon":"Table-library-icon","logoImageContainer":"Table-logo-image-container","logoImage":"Table-logo-image","lgTable":"Table-lg-table","subRow":"Table-sub-row","brandCheckbox":"Table-brand-checkbox","actionColumn":"Table-action-column","logoversionCheckbox":"Table-logoversion-checkbox","urlText":"Table-url-text","badge":"Table-badge"};


//////////////////
// WEBPACK FOOTER
// ./src/Table.css
// module id = 149
// module chunks = 0